import { getDvaApp, useModeldispatcher } from 'umi'

export const getStore = () => {
    return (getDvaApp && getDvaApp()?._store) || {}
}

export const getModel = name => {

    return (
        (useModeldispatcher?.data &&
            useModeldispatcher?.data?.hasOwnProperty(name) &&
            useModeldispatcher?.data[name]) ||
        {}
    )
}
